import { useState, useEffect, useRef } from 'react';

export const useScrollState = (threshold = 0, lockDuration = 100) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const lockRef = useRef(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (lockRef.current) return;

      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const shouldShrink = scrollY > threshold;

      setIsScrolled((prev) => {
        if (prev !== shouldShrink) {
          lockRef.current = true;
          timeoutRef.current = setTimeout(() => {
            lockRef.current = false;
          }, lockDuration);
          return shouldShrink;
        }
        return prev;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [threshold, lockDuration]);

  return isScrolled;
};
